import { useContext } from 'react'

import {
  Button,
  Columns,
  LoadingModule,
  SaveFormModule,
} from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import useAdAccountGroup, { useAdAccountGroupForm } from '@hooks/useAdAccountGroup'

import AdAccounts from '../AdAccounts'
import AdAccountGroupDetails from '../AdAccountGroupDetails'
import PageLayout from '../../../../components/PageLayout'

interface PageContentProps {
  adAccountGroupId: number,
}

const PageContent = (props: PageContentProps) => {
  const { adAccountGroupId } = props

  const pageContext = useContext(PageContext)
  const {
    callbacks: {
      updateAdAccountGroup,
    },
  } = pageContext

  const adAccountGroupPayload = useAdAccountGroup({ id: adAccountGroupId })
  const {
    adAccountGroup,
    callbacks: {
      updateAdAccountGroup: updateFn,
    },
    loading,
    updating,
  } = adAccountGroupPayload

  const adAccountGroupFormPayload = useAdAccountGroupForm(adAccountGroup, { validateOn: 'change' })
  const { entityState, saveEnabled } = adAccountGroupFormPayload

  const updateAdAccountGroupPayload = {
    callbacks: {
      action: updateFn,
    },
    entityParams: entityState,
    toastText: 'Ad Account Group Updated',
  }

  return (
    <PageLayout adAccountGroupPayload={adAccountGroupPayload} activeTabBarItemKey="details">
      <Columns.Main>
        <LoadingModule loading={loading} times={3} />

        {!loading && (
          <>
            <AdAccountGroupDetails adAccountGroupFormPayload={adAccountGroupFormPayload} />

            <SaveFormModule boxProps={{ marginBottom: 'none' }}>
              <Button
                buttonStyle="primaryCreate"
                disabled={!saveEnabled}
                loading={updating}
                marginLeft="auto"
                onClick={() => updateAdAccountGroup(updateAdAccountGroupPayload)}
                size="medium"
              >
                Save Details
              </Button>
            </SaveFormModule>

            <AdAccounts adAccountGroup={adAccountGroup} />
          </>
        )}
      </Columns.Main>
    </PageLayout>
  )
}

export default PageContent
